import { ownerDocument } from './ownerDocument';
export function ownerWindow(node) {
  var doc = ownerDocument(node);
  return doc.defaultView || window;
}